<template>
  <div class="ec-sidebar"
       :class="sidebarClasses"
       :style="sidebarStyles">
    <header>
      <button @click="$emit('close-sidebar')">
        <span class="icon-arrow-down"></span>
        <span class="title">{{ $props.sidebarTitle }}</span>
      </button>
    </header>
    <div class="sidebar-body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-sidebar',
  props: {
    breakpoint: {
      type: String,
      default: 'md',
      validator: val => {
        return ['sm', 'md'].includes(val)
      }
    },
    offsetTop: {
      type: [String, Number],
      default: 0,
      validator: val => {
        return (typeof val === 'string' && !isNaN(parseInt(val))) || (typeof val === 'number' && val < 1000)
      }
    },
    open: Boolean,
    sidebarTitle: String
  },
  computed: {
    sidebarClasses () {
      return {
        [`breakpoint-${this.$props.breakpoint}`]: this.$props.breakpoint,
        open: this.$props.open
      }
    },
    sidebarStyles () {
      return {
        top: typeof this.$props.offsetTop === 'string' ? this.$props.offsetTop : `${this.$props.offsetTop}px`
      }
    }
  },
  watch: {
    open (newVal) {
      if (newVal) {
        document.body.classList.add('vue-modal-open')
        document.getElementsByTagName('html')[0].classList.add('vue-modal-open')
      } else {
        document.body.classList.remove('vue-modal-open')
        document.getElementsByTagName('html')[0].classList.remove('vue-modal-open')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.ec-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: translateX(-100%);
  transition: transform 0.3s;
  z-index: map_get($z-index, modal);

  &.breakpoint-sm {
    @media (map_get($breakpoints, sm)) {
      position: static;
      transform: translateX(0);

      header {
        display: none;
      }
    }
  }

  &.breakpoint-md {
    @media (map_get($breakpoints, md)) {
      position: static;
      transform: translateX(0);

      header {
        display: none;
      }
    }
  }

  &.open {
    transform: translateX(0);
  }

  header {
    background-color: $white;
    display: flex;
    align-items: center;
    padding: 1.6rem;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);

    button {
      padding: 0;
      text-align: left;
      width: 100%;
    }

    span[class^="icon-"] {
      font-size: 1.8rem;
      margin-right: 0.8rem;
      transform: rotate(90deg);
      display: inline-block;

      &::before {
        color: $primary;
      }
    }

    .title {
      font-size: 1.6rem;
      color: $text;
      font-weight: normal;
    }
  }

  .sidebar-body {
    position: relative;
    z-index: -1;
  }
}
</style>
